import { GUEST_PORTAL_FEATURES } from '@/shared/config/platform-config';
/**
 * Guest portal — split-bundle entry App.
 */
import { Routes, Route, Navigate } from "react-router-dom";
import { PortalAppShell } from "@/shared/app/PortalAppShell";
import SafeRoute from "@/components/system/SafeRoute";
import { GuestProvider, GuestLayout } from "@/apps/guest";
import {
  GuestLanding, GuestDashboard, GuestTransport, GuestStays, GuestTours, GuestRequests,
} from "@/apps/guest/routes";
import { portalPath } from "@/shared/app/portalPath";

const S = ({ name, children }: { name: string; children: React.ReactNode }) => (
  <SafeRoute name={name}>{children}</SafeRoute>
);

const GuestApp = () => {
  const p = portalPath("guest");
  const landing = <GuestProvider><S name="GuestLanding"><GuestLanding /></S></GuestProvider>;
  const layout = <GuestProvider><GuestLayout /></GuestProvider>;
  const innerRoutes = (
    <>
      <Route path="dashboard" element={<S name="GuestDashboard"><GuestDashboard /></S>} />
      <Route path="transport" element={<S name="GuestTransport"><GuestTransport /></S>} />
      <Route path="stays" element={<S name="GuestStays"><GuestStays /></S>} />
      <Route path="tours" element={<S name="GuestTours"><GuestTours /></S>} />
      <Route path="requests" element={GUEST_PORTAL_FEATURES.changeRequests ? <S name="GuestRequests"><GuestRequests /></S> : <Navigate to="../dashboard" replace />} />
    </>
  );
  return (
    <PortalAppShell portal="guest">
      <Routes>
        {/* Canonical (subdomain): / renders landing directly */}
        <Route path="/" element={landing} />
        <Route path="/" element={layout}>{innerRoutes}</Route>
        {/* Prefixed alias (Lovable preview) */}
        <Route path="/guest" element={landing} />
        <Route path="/guest" element={layout}>{innerRoutes}</Route>
        {/* Legacy /patient → /guest (or / on subdomain) */}
        <Route path="/patient" element={<Navigate to={p("/")} replace />} />
        <Route path="/patient/dashboard" element={<Navigate to={p("/dashboard")} replace />} />
        <Route path="/patient/transport" element={<Navigate to={p("/transport")} replace />} />
        <Route path="/patient/stays" element={<Navigate to={p("/stays")} replace />} />
        <Route path="/patient/tours" element={<Navigate to={p("/tours")} replace />} />
        <Route path="/patient/requests" element={<Navigate to={p("/requests")} replace />} />
        <Route path="*" element={<Navigate to={p("/")} replace />} />
      </Routes>
    </PortalAppShell>
  );
};

export default GuestApp;
